function isDebug() {
    /*if ( ! window.ctheme_site_settings.debugging ) {
        return false;
    }*/

    if ( ! window.console ) {
        return false;
    }

    return true;
}

const Log = isDebug() ? window.console.log : function() {};

Log.log = Log;
Log.error = isDebug() ? window.console.error : function() {};
Log.info = isDebug() ? window.console.info : function() {};
Log.debug = isDebug() ? window.console.debug : function() {};
Log.warn = isDebug() ? window.console.warn : function() {};
Log.hasDebug = isDebug();

export default Log;
